import { isNilOrEmpty } from '../../../helpers/utils';

export function getResultsLength(data) {
  if (isNilOrEmpty(data)) {
    return 0;
  }
  let count = 0;
  data.forEach((item) => {
    if (item.dataType !== 'EMPTY_FROM_API') {
      count += 1;
    }
  });
  return count;
}
export function getResultsAggregationLength(data) {
  if (isNilOrEmpty(data)) {
    return 0;
  }
  let count = 0;
  data.forEach((item) => {
    if (item.dataType !== 'EMPTY_FROM_API') {
      count += 1;
    }
  });
  return count;
}
